import dayjs from 'dayjs'
import { Card, CardContent, Grid, LinearProgress, Stack, Typography } from '@mui/material'
import { t } from '@lingui/macro'

import { Patient } from '@/core/models/patient.model'

import { InsPatientActions } from './InsPatientActions'

type InsPatientsCardViewProps = {
  data: Patient[]
  loading: boolean
  onOpen: (patientId: string) => void
}

const displayValue = (value?: string | null) => value?.trim() || t`Not provided`

const identityFields = (patient: Patient) => [
  [t`Birth surname`, displayValue(patient.userInfo.birthSurname)],
  [t`Birth given name(s)`, displayValue(patient.userInfo.birthName)],
  [t`Used surname`, displayValue(patient.userInfo.surname)],
  [t`Used given name`, displayValue(patient.userInfo.name)],
  [t`Date of birth`, patient.userInfo.birthday ? dayjs(patient.userInfo.birthday).format('DD/MM/YYYY') : t`Not provided`],
  [t`Sex`, displayValue(patient.userInfo.gender)],
  [t`INS matricule`, displayValue(patient.insNIR)],
]

export function InsPatientsCardView({ data, loading, onOpen }: InsPatientsCardViewProps) {
  return (
    <Stack spacing={2}>
      {loading && <LinearProgress aria-label={t`Loading patients`} />}
      {data.map((patient) => (
        <Card key={patient._id} variant="outlined">
          <CardContent>
            <Stack spacing={2}>
              <Grid container spacing={1.5}>
                {identityFields(patient).map(([label, value]) => (
                  <Grid item xs={12} sm={6} key={label}>
                    <Typography variant="caption" color="text.secondary">
                      {label}
                    </Typography>
                    <Typography variant="body2" fontWeight={500}>
                      {value}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
              <InsPatientActions patientId={patient._id} onOpen={onOpen} />
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Stack>
  )
}
